import { render } from "./Traffic.vue?vue&type=template&id=5e7a3de3&scoped=true"
import script from "./Traffic.vue?vue&type=script&lang=js"
export * from "./Traffic.vue?vue&type=script&lang=js"

import "./Traffic.vue?vue&type=style&index=0&id=5e7a3de3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5e7a3de3"

export default script